module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/AZ-3db043ff050515ab9673fb644c88f2f9.png";